import { useRouteMatch } from 'react-router-dom';

export default function useCanRenderSmartBannerPage() {
  const canRenderBannerPage = useRouteMatch({
    path: [
      '/',
      '/drama/:dramaId(\\d+)/:videoType(eps|behind)/:videoId(\\d+)',
      '/purchase/vip',
      '/purchase/package-group',
      '/feed/campaign',
      '/feed/news',
      '/channel/:channelId(\\d+)',
      '/channel-group/:groupId(\\d+)',
    ],
    exact: true,
  });

  return Boolean(canRenderBannerPage);
}